module.exports = __webpack_public_path__ + "static/media/avalanche.80b49332.svg";